import { apiGet, apiPost, apiPut, setSiteSlug, normalizeSiteSlug } from "./api";

export async function getSites() {
  return apiGet("/sites/", {}, { omitSiteHeader: true });
}

export async function getCurrentSite() {
  return apiGet("/sites/current/", {}, { omitSiteHeader: true });
}

export async function getPublicSiteSettings() {
  return apiGet("/site-settings/");
}

export async function getSiteSettings() {
  return apiGet("/site-settings/");
}

export async function upsertSiteSettings(payload) {
  return apiPost("/site-settings/upsert/", payload);
}

export async function updateSiteSettings(settingId, payload) {
  return apiPut(`/site-settings/${settingId}/`, payload);
}

export function pickBestSite(candidates = []) {
  if (!Array.isArray(candidates) || candidates.length === 0) return null;

  const hostname =
    typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
  const stripped = hostname.replace(/^www\./, "");

  return (
    candidates.find(
      (item) =>
        String(item?.domain || "")
          .toLowerCase()
          .replace(/^www\./, "") === stripped
    ) ||
    candidates.find((item) => item?.is_active) ||
    candidates[0]
  );
}

export async function resolveSiteBundle() {
  const pinnedSlug = normalizeSiteSlug(process.env.REACT_APP_SITE_SLUG);

  if (pinnedSlug) {
    setSiteSlug(pinnedSlug);
    return getPublicSiteSettings();
  }

  try {
    const settingsPayload = await getPublicSiteSettings();
    if (settingsPayload?.site?.slug) {
      setSiteSlug(settingsPayload.site.slug);
    }
    return settingsPayload;
  } catch (error) {
    const currentSite = await getCurrentSite().catch(() => null);
    if (currentSite?.slug) {
      setSiteSlug(currentSite.slug);
      return getPublicSiteSettings();
    }

    const sitesPayload = await getSites().catch(() => []);
    const sites = Array.isArray(sitesPayload)
      ? sitesPayload
      : sitesPayload?.results || sitesPayload?.data || [];

    const bestSite = pickBestSite(sites);

    if (!bestSite?.slug) {
      throw error;
    }

    setSiteSlug(bestSite.slug);
    return getPublicSiteSettings();
  }
}

export async function getAdminSiteSettings() {
  return getSiteSettings();
}
